module.exports = __webpack_public_path__ + "img/delivery_icon.d0595ffd.svg";